export const arrayOr = (value, fallback = []) => (
  Array.isArray(value) ? value : fallback
);

export const arrayFrom = (value) => arrayOr(value);

export const arrayCopyFrom = (value) => [ ...arrayFrom(value) ];

export const compactArray = (value) => arrayFrom(value).filter(Boolean);

export const filterArray = (value, predicate) => arrayFrom(value).filter(predicate);

export const hasArrayItems = (value) => Array.isArray(value) && value.length > 0;

export const populatedArrayOr = (value, fallback = []) => (
  hasArrayItems(value) ? value : arrayFrom(fallback)
);

export const arrayFromValue = (value) => {
  if (Array.isArray(value)) return value;
  if (value == null) return [];

  return [value];
};

export const arrayWithToggledValue = (values, value, checked) => {
  const currentValues = arrayFrom(values);
  if (checked) return Array.from(new Set([ ...currentValues, value ]));

  return currentValues.filter((currentValue) => currentValue !== value);
};
